module.exports = __webpack_public_path__ + "img/mail.2abfbd5d.svg";